import { Dispatch, MouseEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Language } from '@mui/icons-material'
import { Button, Menu, MenuItem } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import oldCookies from 'js-cookie'

import { Flex } from '@/ui'

import { langList } from '@/utils/app/language'
import { various } from '@/utils/app/theme'
import { assets } from '@/utils/constants'

import type { Locale } from '@/types/app/language'

const useStyles = makeStyles((theme: Theme) => ({
    setting: {
        height: '45px',
        margin: various.padding,
        color: theme.palette.secondary.main,
        borderColor: theme.palette.secondary.main,
        borderRadius: various.borderRadius,
    },

    langageIcon: {
        height: '35px',
    },

    flagBox: {
        width: '50px',
        paddingRight: '5px',
    },

    flag: {
        height: '20px',
        maxWidth: '100%',
    },
}))

type ChooseLanguageProperties = {
    setWantsNavigate: Dispatch<boolean>
}

export const ChooseLanguage = ({
    setWantsNavigate,
}: Readonly<ChooseLanguageProperties>) => {
    const classes = useStyles()
    const { i18n } = useTranslation()

    const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null)

    const isOpen = Boolean(anchorElement)
    const langages = langList()

    /** Open the langage selection. */
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorElement(event.currentTarget)
    }

    /** Close the langage selection. */
    const handleClose = () => {
        if (setWantsNavigate) {
            setWantsNavigate(false)
        }

        setAnchorElement(null)
    }

    /** Change the langage for the new selected. */
    const handleChangeLangage = (locale: Locale) => {
        i18n.changeLanguage(locale)
        oldCookies.set('i18next', locale)
    }

    return (
        <>
            <Button
                className={classes.setting}
                variant='outlined'
                onClick={handleClick}
            >
                <Language className={classes.langageIcon} />
            </Button>

            <Menu
                anchorEl={anchorElement}
                open={isOpen}
                onClose={handleClose}
            >
                {langages.map((langage) => (
                    <MenuItem
                        key={langage.locale}
                        onClick={() => {
                            handleClose()
                            // @ts-expect-error Remove langList
                            handleChangeLangage(langage.locale)
                        }}
                    >
                        <Flex className={classes.flagBox}>
                            <img
                                className={classes.flag}
                                src={assets.flags[langage.locale]}
                                alt={langage.name}
                            />
                        </Flex>

                        {langage.name}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}
